import React, { useState, useEffect } from 'react';
import axios from "axios";
import TextEditor from "./TextEditor";
import DispCard from "./DispCard";
import '../App.css'

const UploadForm = () => {
    const [category, setCategory] = useState(
        localStorage.getItem("category") || "not_selected"
      ); // Default to "Not Selected"
    const [formData, setFormData] = useState(
      JSON.parse(localStorage.getItem('formData')) || { // Get from localStorage or default
        header: "",
        headerColor: "",
        title: "",
        titleSize: "",
        titleColor: "",
        desc: "",
        descColor: "",
        descSize: "",
        background: "",
        animation: "",
        noise: false,
        btnText: "",
        btnColor: "",
        btnSize: "",
        svg: true,
        link: "",
      }
    );
    const [editorContent, setEditorContent] = useState(localStorage.getItem('editorContent') || ""); // Get from localStorage or default
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [previewData, setPreviewData] = useState(formData);
  
    useEffect(() => {
      localStorage.setItem('category', category); // Save category to localStorage
      localStorage.setItem('formData', JSON.stringify(formData)); // Save formData to localStorage
      localStorage.setItem('editorContent', editorContent); // Save editorContent to localStorage
  
      setPreviewData(formData); // Update preview whenever formData changes
    }, [category, formData, editorContent]); // Add category and editorContent to dependencies
  
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    };
  
    const handleEditorChange = (content) => {
      setEditorContent(content);
    };
  

    console.log(process.env.REACT_APP_CONTENT_URL)

    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
      setMessage("");

      if (category === "not_selected") {
        setMessage("Please select a category before submitting.");
        setLoading(false);
        return;
      }
  
      const dataToSend = {
        ...formData,
        category: category, // Include category in the dataToSend object
        content: category === "product" ? "" : editorContent,
      };
  
      try {
        await axios.post(
         process.env.REACT_APP_CONTENT_URL, // URL is now just the base URL
          dataToSend,
          { headers: { "Content-Type": "application/json" } }
        );
        setMessage("Content uploaded successfully!");
        // Reset form data after successful upload (optional - if you want the form to clear)
        setFormData({
          header: "",
          headerColor: "",
          title: "",
          titleSize: "",
          titleColor: "",
          desc: "",
          descColor: "",
          descSize: "",
          background: "",
          animation: "",
          noise: false,
          btnText: "",
          btnColor: "",
          btnSize: "",
          svg: true,
          link: "",
        });
        setEditorContent("");
        setCategory("not_selected") //reset category too
      } catch (error) {
        setMessage("Failed to upload content. Please try again.");
        console.error("Upload error:", error);
      } finally {
        setLoading(false);
      }
    };
  
    return (
      <div className="flex flex-col w-full px-4 bg-[#000000]"> 
    
        <div className="flex p-4 justify-between items-center gap-10 bg-[#000000] flex-wrap lg:flex-nowrap">
        
          {/* Form Section */}
          <div className="w-full lg:w-[60%] mx-auto p-6 rounded-md shadow-md text-black"> 
            <h2 className="text-2xl font-semibold mb-4" style={{ color: formData.headerColor }}>
              Upload New {category !== "not_selected" ? category.charAt(0).toUpperCase() + category.slice(1) : ""}
            </h2>
    
            <form className="flex flex-wrap items-center justify-between gap-4" onSubmit={handleSubmit}>
              
              {/* Category Select */}
              <label className="block w-full text-white font-medium">Select Category:</label>
              <select 
                value={category} 
                onChange={(e) => setCategory(e.target.value)} 
                className="w-full p-2 border rounded"
              >
                <option value="not_selected">-- Select a Category --</option>
                <option value="product">Products</option>
                <option value="research">Research</option>
                <option value="story">Stories</option>
              </select>
    
              {/* Input Fields */}
              {Object.keys(formData).filter(key => key !== 'id').map((key) => (
                <div key={key} className="w-full sm:w-[48%] mb-4">
                  <label className="block text-white font-medium">{key.charAt(0).toUpperCase() + key.slice(1)}:</label>
                  {key === 'noise' || key === 'svg' ? (
                    <select 
                      name={key} 
                      value={formData[key]} 
                      onChange={handleInputChange} 
                      className="w-full p-2 border rounded"
                    >
                      <option value={true}>True</option>
                      <option value={false}>False</option>
                    </select>
                  ) : (
                    <input
                      type="text"
                      name={key}
                      value={formData[key]}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded"
                    />
                  )}
                </div>
              ))}
    
              {/* Submit Button */}
              <button
                type="submit"
                className={`w-full ${formData.btnColor} text-white bg-lime-700 p-2 rounded hover:opacity-80`}
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
    
              {message && <p className="w-full text-center text-green-500">{message}</p>}
            </form>
          </div>
    
          {/* Preview Section */}
          <div className="w-full flex flex-col items-center justify-center lg:w-[40%] mt-8 lg:mt-0"> 
            <h2 className="text-2xl font-semibold mb-4 text-white">Display Card Preview</h2>
            {previewData ? <DispCard {...previewData} /> : <p className="text-gray-400">No preview available yet.</p>}
          </div>
    
        </div>
    
        {/* Text Editor for Research & Story */}
        {(category === "research" || category === "story") && (
          <div className="w-full mt-6 flex justify-center">
            <div className="w-full max-w-3xl mb-44 h-full">
              <label className="block mb-2 font-medium text-white">Content:</label>
              <TextEditor onContentChange={handleEditorChange} content={editorContent} />
            </div>
          </div>
        )}
      </div>
    );
};

export default UploadForm;